import React from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

import Aux from './Aux'

class ModalExample extends React.Component {
  onOk = event => {
    this.props.toggle()
    this.props.ok()
  }

  render() {
    return (
      <Aux>
        <Modal isOpen={this.props.show} toggle={this.props.toggle}>
          <ModalHeader toggle={this.toggle}>
            {this.props.title}
          </ModalHeader>
          <ModalBody>
            {this.props.children}
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={this.onOk}>Sim</Button>
            &nbsp;
            <Button color="secondary" onClick={this.props.toggle}>Não</Button>
          </ModalFooter>
        </Modal>
      </Aux>
    );
  }
}

export default ModalExample;


// WEBPACK FOOTER //
// ./src/components/hoc/ModalConfirm.js